import {showNotification} from 'platform/components';

import {useEagGridConfig} from '../context/useEagGridConfig';
import {createDataApi} from './dataApi';

const handleNavigationError = () => showNotification.error();

/** Detail pages and editing dialogs have no mounted grid store. */
export function useNavigationDataApi(gridCode: string) {
  const {app} = useEagGridConfig();

  return createDataApi({
    gridCode,
    app,
    presetInstanceId: undefined,
    handleApiError: handleNavigationError,
    handleMutationError: handleNavigationError,
    handleBestEffortError: handleNavigationError,
  });
}
